module.exports = __webpack_public_path__ + "img/bKash.e074f399.png";